import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import classNames from '../../../node_modules/classnames/index.js';
import styles from './index.module.scss.js';

var DropdownItem = function (_a) {
    var children = _a.children, href = _a.href, target = _a.target, _b = _a.isLink, isLink = _b === void 0 ? false : _b, onClick = _a.onClick;
    return (jsxs(Fragment, { children: [!isLink && (jsx("div", __assign({ className: styles.menuLink }, { children: jsx("span", { children: children }, void 0) }), void 0)), isLink && (jsxs("div", __assign({ className: classNames(styles.menuLink, isLink && styles.isLink) }, { children: [!href && !onClick && children, (href || onClick) && (jsx("a", __assign({ href: href, target: target, onClick: onClick }, { children: children }), void 0))] }), void 0))] }, void 0));
};

export { DropdownItem as default };
